// ── 담당자 이름/직급 분리 유틸 ──────────────────────────────────────────────
// 업체관리(companies)의 "담당자" 칸은 자유 텍스트라 "홍길동 과장"처럼 이름과 직급이 한 칸에
// 같이 입력돼 있는 경우가 많다. 출고등록/견적서 작성에서 이 값을 그대로 담당자 칸에 밀어넣으면
// 직급까지 이름처럼 보이므로, 자주 쓰이는 직급 키워드를 찾아 이름과 직급을 분리해준다.
// (2026-08 추가 — "업체관리에서 정보를 가져올 때 담당자는 이름만, 대표/과장/차장/주임/연구원
// 등 직급은 직급란에 자동으로 입력되게" 요청)
const TITLES = [
  '대표이사', '대표', '회장', '부회장', '사장', '부사장', '전무', '상무', '이사',
  '부장', '차장', '과장', '대리', '주임', '사원', '연구원', '팀장', '실장',
  '소장', '원장', '매니저', '담당', '책임', '선임', '수석',
].sort((a, b) => b.length - a.length); // 긴 단어부터 매칭(예: "대표이사"가 "대표"보다 먼저 걸리게)

export function parseManagerTitle(raw) {
  const value = (raw || '').trim();
  if (!value) return { name: '', position: '' };

  const tokens = value.split(/\s+/).filter(Boolean);
  if (tokens.length > 1) {
    // 공백으로 나뉜 경우 — 맨 앞 또는 맨 뒤 토큰이 직급 키워드와 정확히 일치하면 그것만 떼어내고
    // 나머지 전부를 이름으로 취급한다(예: "과장 홍길동", "홍길동 과장" 둘 다 지원).
    if (TITLES.includes(tokens[0])) return { position: tokens[0], name: tokens.slice(1).join(' ') };
    if (TITLES.includes(tokens[tokens.length - 1])) return { position: tokens[tokens.length - 1], name: tokens.slice(0, -1).join(' ') };
  }
  // 공백 없이 붙어있는 경우(예: "홍길동과장") — 앞/뒤에 직급이 붙어있는지 확인.
  const suffixTitle = TITLES.find(t => value.endsWith(t) && value.length > t.length);
  if (suffixTitle) return { position: suffixTitle, name: value.slice(0, value.length - suffixTitle.length) };
  const prefixTitle = TITLES.find(t => value.startsWith(t) && value.length > t.length);
  if (prefixTitle) return { position: prefixTitle, name: value.slice(prefixTitle.length) };

  // 직급으로 보이는 부분이 전혀 없으면(이름만 등록돼 있던 경우) 그대로 이름으로 취급.
  return { name: value, position: '' };
}
